<template>

<core-panel>

	<template v-slot:head>

		<h1>Play Streaks</h1>

		<p>The longest {{ periodText[period] }} streaks of plays together.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in streaks" :subtext="item.subtext" :key="index" :count-text="period" :dark="true" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'streaks',
			streaks: [],
            periodText: {
                year: 'yearly',
                month: 'monthly',
                week: 'weekly',
                day: 'daily'
            }
		}

	},

    computed: {

        period: function() {

            return this.$store.getters['filter/insights/players/streaks/period']

        }

    },

	methods: {

		response: function(json) {

			this.streaks = json.streaks.streaks

		}

	}

}

</script>